module.exports = __webpack_public_path__ + "static/media/logo.b21fc710.png";